import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Warning } from '../../Warning/Warning';
import { t } from 'i18next';
import { useWarningClick } from '../useWarningClick';
const useStyles = makeStyles(() => ({
    warningContainer: {
        display: 'flex',
        gap: 30,
        width: 'fit-content',
        height: 'fit-content',
        margin: 'auto auto',
    },
    warningWrapper: {
        display: 'flex',
        flexDirection: 'column',
        gap: 20,
        textAlign: 'center',
    },
}));
export const WarningsXsBlock = (props) => {
    const { criticalCount, earlyCount } = props;
    const { onCriticalClick, onEarlyClick } = useWarningClick();
    const classes = useStyles();
    return (React.createElement("div", { className: classes.warningContainer },
        React.createElement(Warning, { onClick: onCriticalClick, color: "#E46A68", diameter: 90, fontSize: 28, amount: criticalCount, title: t('common:critical') }),
        React.createElement(Warning, { onClick: onEarlyClick, color: "#FA9E2D", diameter: 90, fontSize: 28, amount: earlyCount, title: t('common:early') })));
};
//# sourceMappingURL=WarningsXSBlock.js.map